import { AxiosPromise } from 'axios';

import { browserApiRequest } from '../apiRequest/browserApiRequest';

export type CampaignCodeValidationReason = 'invalid' | 'expired' | 'already_used' | 'deleted' | null;

export interface ValidateCampaignCodeResponse {
	valid: boolean;
	reason: CampaignCodeValidationReason;
}

export interface ValidateCampaignCodeArgs {
	campaignId: string;
	code: string;
}

export function postValidateCampaignCode({
	campaignId,
	code,
}: ValidateCampaignCodeArgs): AxiosPromise<ValidateCampaignCodeResponse> {
	return browserApiRequest({
		endpoint: `calm-partnerships/campaigns/${campaignId}/validate-code`,
		method: 'POST',
		body: {
			code,
		},
	});
}
